query getManufacturerSeo($manufacturer: String) {
  manufacturer(code: $manufacturer) {
    id
    name
    image
    icon
    imageLight
    iconLight
    seoData {
      metaTitle
      metaDescription
      seoText
      updated
      created
      seoTitle
      h1
      ogTitle
      ogDescription
    }
  }
}
